import { Link, Box } from "@mui/material";
import { useAppTheme } from "../../logic/useAppTheme";
const privacyPolicyUrl = 'https://www.closesimple.com/closesimple-portal-privacy-policy'
const termsOfUseUrl = 'https://www.closesimple.com/portal-end-user-license-agreement'

export function Legalese({ textColor }: {
  textColor?: string;
}) {
  // const [termsOpen, setTermsOpen] = useState(false)
  const theme = useAppTheme() 
  const mainColor = theme.palette.primary.main

  return (
    <>
      <Box gap={2} sx={{
        display: 'flex', flexDirection: 'column', color: textColor || mainColor, fontSize: '14px',
        justifyContent: 'center', alignItems: 'center'
      }}>
        <Link underline="hover" sx={{ color: 'inherit', textAlign: 'center' }} href={privacyPolicyUrl} target="_blank">CloseSimple Portal <br/> Privacy Policy</Link>
        <Link underline="hover" sx={{ color: 'inherit', textAlign: 'center' }} href={termsOfUseUrl} target="_blank">CloseSimple Portal <br/> EULA/Terms of Use</Link>
      </Box>

      {/* <Dialog
        open={termsOpen}
        onClose={() => {setTermsOpen(false)}}
        fullWidth={true}
      >
        <DialogContent>
          <Box
            component='img'
            src={termsOfUse}
            sx={{ width: '100%'}}
          >

          </Box>

        </DialogContent>
      </Dialog> */}
    </>
  )
}
